import ModalHandler from './ModalHandler';

export default ModalHandler;
